@if (!isFormRequired()) {
  <label
    class="relative flex cursor-pointer justify-center"
    title="{{ 'form.form_switch' | translate }}">
    <input
      type="checkbox"
      class="peer sr-only"
      [checked]="isFormEnable()"
      (change)="onInput()" />
    <div
      class="peer peer-focus:ring-accent-focus/40 dark:peer-focus:ring-accent-focus relative mt-1 h-3.5 w-7 rounded-full bg-zinc-400 peer-checked:bg-teal-800 peer-focus:ring-4 peer-focus:outline-none after:absolute after:start-px after:top-px after:h-3 after:w-3 after:rounded-full after:border after:border-zinc-300 after:bg-white after:transition-all after:content-[''] peer-checked:after:translate-x-4 peer-checked:after:border-white rtl:peer-checked:after:-translate-x-4 dark:border-zinc-600 dark:bg-zinc-700 dark:peer-checked:bg-teal-800"></div>
    <span class="ms-3 text-sm font-medium text-zinc-900 dark:text-zinc-300"></span>
  </label>
} @else {
  <span class="text-red-500">*</span>
}
